// BestCars Premium - Mock Data
// All data sourced from the original bestcars.com.pt website

export const companyInfo = {
  name: "BestCars",
  subtitle: "Comércio de Automóveis Lda",
  slogan: "A Sua Escolha de Confiança no Mundo Automóvel",
  phone: "+351 932 074 479",
  phoneDisplay: "932 074 479",
  whatsapp: "https://wa.me/351932074479",
  facebook: "https://www.facebook.com/bestcars19",
  instagram: "https://www.instagram.com/bestcars19stand",
  email: "bestcars.automovel@gmail.com",
  address: "Vala do Carregado, Vila Franca de Xira",
  fullAddress: "Estrada da Vala N\u00BA3, Stand Bestcars, Vala do Carregado, 2600-733, Vila Franca de Xira",
  legalName: "Stand João Lobato Guerreiro, Unipessoal Lda.",
  nif: "515514411",
  complaintsBookUrl: "https://www.livroreclamacoes.pt/Inicio/",
  adrUrl: "https://www.arbitragemauto.pt/",
  adrName: "Centro de Arbitragem do Sector Automóvel",
  adrEmail: "geral@arbitragemauto.pt",
  adrPhone: "+351 217 951 696",
  adrAddress: "Av. da República, 44 - 3.º Esq., 1050-194 Lisboa",
  privacyContactEmail: "bestcars.automovel@gmail.com",
  googleRating: 4.7,
  googleReviews: 41,
  workingHours: {
    weekdays: "10:00 - 13:00 / 14:00 - 19:00",
    saturday: "10:00 - 13:00 / 14:00 - 17:00",
    sunday: "Encerrado"
  },
  workingHoursDetailed: [
    { day: "Segunda-feira", hours: "10:00 - 13:00 / 14:00 - 19:00" },
    { day: "Terça-feira", hours: "10:00 - 13:00 / 14:00 - 19:00" },
    { day: "Quarta-feira", hours: "10:00 - 13:00 / 14:00 - 19:00" },
    { day: "Quinta-feira", hours: "10:00 - 13:00 / 14:00 - 19:00" },
    { day: "Sexta-feira", hours: "10:00 - 13:00 / 14:00 - 19:00" },
    { day: "Sábado", hours: "10:00 - 13:00 / 14:00 - 17:00" },
    { day: "Domingo", hours: "Encerrado" },
  ]
};

export const cars = [
  {
    id: 1,
    brand: "VW",
    model: "Golf",
    version: "1.5 TSI ACT OPF DSG Highline",
    date: "02/2018",
    year: 2018,
    mileage: 73500,
    mileageDisplay: "73.500 km",
    horsepower: 150,
    fuel: "Gasolina",
    transmission: "Automática",
    price: 18999,
    priceDisplay: "18 999 €",
    badge: "FULL EXTRAS",
    badgeColor: "#C41E3A",
    category: "Utilitário",
    color: "Cinza",
    doors: 5,
    images: [
      "https://images.unsplash.com/photo-1616422285623-13ff0162193c?w=800&q=80",
      "https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=800&q=80",
      "https://images.unsplash.com/photo-1619405399517-d7fce0f13302?w=800&q=80"
    ],
    featured: true,
    description: "Volkswagen Golf 1.5 TSI com caixa DSG automática, versão Highline com todos os extras. Viatura em excelente estado, revisão completa efetuada.",
    features: ["Navegação GPS", "Câmara traseira", "Sensores estacionamento", "LED", "Climatização automática", "Cruise Control adaptativo", "Apple CarPlay", "Android Auto"]
  },
  {
    id: 2,
    brand: "BMW",
    model: "216 Active Tourer",
    version: "d Line Sport",
    date: "01/2016",
    year: 2016,
    mileage: 93000,
    mileageDisplay: "93.000 km",
    horsepower: 116,
    fuel: "Diesel",
    transmission: "Manual",
    price: 15990,
    priceDisplay: "15 990 €",
    badge: "NACIONAL",
    badgeColor: "#1a1a2e",
    category: "Monovolume",
    color: "Preto",
    doors: 5,
    images: [
      "https://images.unsplash.com/photo-1555215695-3004980ad54e?w=800&q=80",
      "https://images.unsplash.com/photo-1556189250-72ba954cfc2b?w=800&q=80",
      "https://images.unsplash.com/photo-1549925245-8a7a48495212?w=800&q=80"
    ],
    featured: true,
    description: "BMW 216 Active Tourer d Line Sport, viatura nacional com livro de revisões completo. Interior em ótimo estado, motor sem qualquer problema.",
    features: ["Navegação GPS", "Sensores estacionamento", "Ar condicionado", "Bluetooth", "Cruise Control", "Start/Stop", "Volante multifunções"]
  },
  {
    id: 3,
    brand: "Peugeot",
    model: "308",
    version: "1.6 Hybrid GT e-EAT8",
    date: "05/2023",
    year: 2023,
    mileage: 37000,
    mileageDisplay: "37.000 km",
    horsepower: 225,
    fuel: "Híbrido Plug-In",
    transmission: "Automática",
    price: 29990,
    priceDisplay: "29 990 €",
    badge: "HÍBRIDO PLUG IN",
    badgeColor: "#0d7377",
    category: "Utilitário",
    color: "Verde",
    doors: 5,
    images: [
      "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=800&q=80",
      "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800&q=80",
      "https://images.unsplash.com/photo-1617531653332-bd46c24f2068?w=800&q=80"
    ],
    featured: true,
    description: "Peugeot 308 GT Híbrido Plug-In, praticamente novo com apenas 37.000 km. Tecnologia de ponta, consumos reduzidos e performance excecional.",
    features: ["i-Cockpit 3D", "Navegação 3D", "Câmara 360°", "Faróis Matrix LED", "Carregamento rápido", "Modo 100% elétrico", "Bancos aquecidos", "Teto panorâmico"]
  },
  {
    id: 4,
    brand: "Peugeot",
    model: "Partner",
    version: "1.6 BlueHDi L2 Pro 3L",
    date: "10/2018",
    year: 2018,
    mileage: 174000,
    mileageDisplay: "174.000 km",
    horsepower: 100,
    fuel: "Diesel",
    transmission: "Manual",
    price: 11250,
    priceDisplay: "11 250 €",
    badge: "LONGA / 3 LUG",
    badgeColor: "#4a4a4a",
    category: "Ligeiro de Mercadorias",
    color: "Branco",
    doors: 5,
    images: [
      "https://images.unsplash.com/photo-1632245889029-e406faaa34cd?w=800&q=80",
      "https://images.unsplash.com/photo-1612825173281-9a193378527e?w=800&q=80"
    ],
    featured: false,
    description: "Peugeot Partner versão longa com 3 lugares. Ideal para profissionais. Viatura bem estimada e com manutenção em dia.",
    features: ["Ar condicionado", "Bluetooth", "Sensores estacionamento", "3 Lugares", "Versão longa", "Porta lateral deslizante"]
  },
  {
    id: 5,
    brand: "Audi",
    model: "A4 Avant",
    version: "2.0 TDI Business Line S-line",
    date: "09/2014",
    year: 2014,
    mileage: 160000,
    mileageDisplay: "160.000 km",
    horsepower: 136,
    fuel: "Diesel",
    transmission: "Manual",
    price: 16990,
    priceDisplay: "16 990 €",
    badge: "NACIONAL",
    badgeColor: "#1a1a2e",
    category: "Carrinha",
    color: "Cinza",
    doors: 5,
    images: [
      "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&q=80",
      "https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?w=800&q=80",
      "https://images.unsplash.com/photo-1614200179396-2bdb77ebf81b?w=800&q=80"
    ],
    featured: true,
    description: "Audi A4 Avant com pacote S-line, viatura nacional com histórico completo. Interior desportivo e elegante.",
    features: ["Pacote S-line", "Navegação GPS", "Xenon", "Bancos desportivos", "Climatização bi-zona", "Cruise Control", "Bluetooth"]
  },
  {
    id: 6,
    brand: "SEAT",
    model: "Leon",
    version: "2.0 TDI FR S/S",
    date: "05/2018",
    year: 2018,
    mileage: 199000,
    mileageDisplay: "199.000 km",
    horsepower: 150,
    fuel: "Diesel",
    transmission: "Manual",
    price: 18999,
    priceDisplay: "18 999 €",
    badge: "FULL EXTRAS",
    badgeColor: "#C41E3A",
    category: "Utilitário",
    color: "Preto",
    doors: 5,
    images: [
      "https://images.unsplash.com/photo-1606611013016-969c19ba29a6?w=800&q=80",
      "https://images.unsplash.com/photo-1617469767053-d3b523a0b982?w=800&q=80"
    ],
    featured: false,
    description: "SEAT Leon FR com motor 2.0 TDI de 150cv, versão desportiva com todos os extras. Viatura muito bem estimada.",
    features: ["Versão FR", "LED", "Navegação GPS", "Câmara traseira", "Climatização automática", "Bancos desportivos", "Start/Stop"]
  },
  {
    id: 7,
    brand: "Peugeot",
    model: "308 SW",
    version: "1.6 BlueHDi GT Line",
    date: "09/2016",
    year: 2016,
    mileage: 167000,
    mileageDisplay: "167.000 km",
    horsepower: 120,
    fuel: "Diesel",
    transmission: "Manual",
    price: 13900,
    priceDisplay: "13 900 €",
    badge: "NACIONAL",
    badgeColor: "#1a1a2e",
    category: "Carrinha",
    color: "Azul",
    doors: 5,
    images: [
      "https://images.unsplash.com/photo-1619405399517-d7fce0f13302?w=800&q=80",
      "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800&q=80"
    ],
    featured: false,
    description: "Peugeot 308 SW GT Line, carrinha espaçosa e elegante. Viatura nacional com manutenção completa.",
    features: ["Versão GT Line", "i-Cockpit", "Navegação GPS", "LED", "Sensores estacionamento", "Cruise Control", "Bluetooth"]
  },
  {
    id: 8,
    brand: "Mercedes-Benz",
    model: "GLA 250",
    version: "e AMG Line",
    date: "01/2022",
    year: 2022,
    mileage: 105000,
    mileageDisplay: "105.000 km",
    horsepower: 218,
    fuel: "Híbrido Plug-In",
    transmission: "Automática",
    price: 36990,
    priceDisplay: "36 990 €",
    badge: "HÍBRIDO PLUG-IN",
    badgeColor: "#0d7377",
    category: "SUV/TT",
    color: "Preto",
    doors: 5,
    images: [
      "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800&q=80",
      "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&q=80",
      "https://images.unsplash.com/photo-1617531653332-bd46c24f2068?w=800&q=80"
    ],
    featured: true,
    description: "Mercedes-Benz GLA 250 e AMG Line, SUV híbrido plug-in com acabamento premium. Tecnologia MBUX de última geração.",
    features: ["AMG Line", "MBUX", "Câmara 360°", "LED Multibeam", "Bancos aquecidos", "Teto panorâmico", "Carregamento rápido", "Modo elétrico"]
  },
  {
    id: 9,
    brand: "Mercedes-Benz",
    model: "C 200",
    version: "d Station 9G-TRONIC Avantgarde",
    date: "06/2020",
    year: 2020,
    mileage: 143500,
    mileageDisplay: "143.500 km",
    horsepower: 160,
    fuel: "Diesel",
    transmission: "Automática",
    price: 25990,
    priceDisplay: "25 990 €",
    badge: "JANTES 18 / GPS",
    badgeColor: "#8B6914",
    category: "Carrinha",
    color: "Azul",
    doors: 5,
    images: [
      "https://images.unsplash.com/photo-1553440569-bcc63803a83d?w=800&q=80",
      "https://images.unsplash.com/photo-1617531653332-bd46c24f2068?w=800&q=80",
      "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&q=80"
    ],
    featured: true,
    description: "Mercedes-Benz C 200 d Station com caixa automática 9G-TRONIC, acabamento Avantgarde. Jantes 18 e navegação GPS incluídos.",
    features: ["9G-TRONIC", "Avantgarde", "Jantes 18\"", "Navegação GPS", "LED", "Climatização bi-zona", "Sensores estacionamento", "Cruise Control"]
  }
];

export const services = [
  {
    id: 1,
    title: "Serviços de Oficina",
    description: "Manutenção preventiva e corretiva com técnicos especializados. Garantimos o melhor cuidado para a sua viatura.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=600&q=80",
    link: "/servicos/oficina"
  },
  {
    id: 2,
    title: "Encomenda de Viatura",
    description: "Encomende o carro dos seus sonhos. Pesquisamos, negociamos e entregamos a viatura ideal, chave na mão.",
    icon: "Search",
    image: "https://images.pexels.com/photos/4173190/pexels-photo-4173190.jpeg?w=600",
    link: "/servicos/consultadoria"
  },
  {
    id: 3,
    title: "Intermediação de Crédito",
    description: "Facilitamos o financiamento da sua viatura com as melhores condições do mercado. Processo simples e rápido.",
    icon: "CreditCard",
    image: "https://images.pexels.com/photos/9822745/pexels-photo-9822745.jpeg?w=600",
    link: "/servicos/credito"
  },
  {
    id: 4,
    title: "Compramos o seu Carro",
    description: "Avaliação gratuita e imediata. Compramos a sua viatura atual com as melhores condições.",
    icon: "HandCoins",
    image: "https://images.unsplash.com/photo-1580679568899-be51739ba2df?w=600&q=80",
    link: "/servicos/compramos"
  }
];

export const brands = [
  { name: "Audi", logo: "https://www.carlogos.org/car-logos/audi-logo-2016.png" },
  { name: "BMW", logo: "https://www.carlogos.org/car-logos/bmw-logo-2020.png" },
  { name: "Mercedes-Benz", logo: "https://www.carlogos.org/car-logos/mercedes-benz-logo-2011.png" },
  { name: "Peugeot", logo: "https://www.carlogos.org/car-logos/peugeot-logo-2010.png" },
  { name: "SEAT", logo: "https://www.carlogos.org/car-logos/seat-logo-2012.png" },
  { name: "Volkswagen", logo: "https://www.carlogos.org/car-logos/volkswagen-logo-2019.png" }
];

export const testimonials = [
  {
    id: 1,
    name: "Elsa Sousa",
    initial: "E",
    text: "Há 8 anos atrás fui pela primeira vez comprar o meu carro, trataram de tudo muita paciência com o cliente. Passando 8 anos fui lá novamente trocar de carro, continuam a ser excelentes!",
    rating: 5,
    source: "Google"
  },
  {
    id: 2,
    name: "Tó Gui",
    initial: "T",
    text: "Pela segunda vez, adquiri uma viatura usada na BestCars, prima pela simpatia, disponibilidade e honestidade. Recomendo vivamente.",
    rating: 5,
    source: "Google"
  },
  {
    id: 3,
    name: "Ricardo Gonçalves",
    initial: "R",
    text: "Excelente transação. Vendedor fiável e super prestável. A transação correu bem, sem qualquer problema e com atenção especial nos serviços que o carro fez antes da entrega. Recomendo 5*",
    rating: 5,
    source: "Google"
  },
  {
    id: 4,
    name: "A. Filipe Menezes",
    initial: "A",
    text: "Descobri este Stand através do Standvirtual, onde procedi à troca da minha viatura. Fui atendido desde o primeiro dia com o máximo profissionalismo e educação.",
    rating: 5,
    source: "Google"
  },
  {
    id: 5,
    name: "Gabriel Camilo",
    initial: "G",
    text: "Serviço impecável e atendimento de excelência! Equipa profissional, atenciosa e sempre disposta a ajudar. Recomendo vivamente!",
    rating: 5,
    source: "Google"
  },
  {
    id: 6,
    name: "Leonardo Mendes",
    initial: "L",
    text: "Cuidado impecável, carros excelentes, experiência personalizada.",
    rating: 5,
    source: "Google"
  },
  {
    id: 7,
    name: "Ruben Gama",
    initial: "R",
    text: "Nunca fui tão bem recebido num stand, grande profissionalismo por parte de todo o staff que desde o primeiro instante foi de encontro às minhas necessidades.",
    rating: 5,
    source: "Google"
  },
  {
    id: 8,
    name: "Guilherme",
    initial: "G",
    text: "Boa qualidade, atendimento excelente. Recomendo com toda certeza.",
    rating: 5,
    source: "Google"
  },
  {
    id: 9,
    name: "Raul Boal",
    initial: "R",
    text: "5 estrelas. Não podia pedir melhor serviço. São pessoas boas e de confiança, recomendo.",
    rating: 5,
    source: "Google"
  },
  {
    id: 10,
    name: "Eduardo Ribeiro",
    initial: "E",
    text: "Devo dizer que foi dos stands onde melhor fui recebido. As viaturas estão super bem cuidadas, é tudo feito com o maior profissionalismo.",
    rating: 5,
    source: "Google"
  },
  {
    id: 11,
    name: "Pedro Roxo",
    initial: "P",
    text: "Agilidade, rapidez, rigor e confiança em todo o processo. Nada a apontar.",
    rating: 5,
    source: "Google"
  },
  {
    id: 12,
    name: "Claudia Claudia",
    initial: "C",
    text: "Melhor stand, melhores pessoas. Recomendo a 100%, super satisfeita com o meu carro!",
    rating: 5,
    source: "Google"
  }
];

export const aboutData = {
  title: "Stand BestCars: A Sua Escolha de Confiança no Mundo Automóvel.",
  paragraphs: [
    "Somos uma equipa jovem e dinâmica, sempre em busca de evolução para oferecer as melhores soluções aos nossos clientes. No stand BestCars, apostamos na qualidade das nossas viaturas e na excelência da assistência pós-venda.",
    "Os nossos clientes têm à disposição uma vasta gama de viaturas no nosso espaço, podendo também recorrer ao nosso serviço de consultoria automóvel. Ajudamos na pesquisa, seleção e negociação das melhores ofertas 'Chave na mão', garantindo uma experiência de compra personalizada e eficiente.",
    "O nosso principal objetivo é a satisfação e fidelização dos clientes, trabalhando diariamente com transparência, qualidade e preços competitivos. Venha conhecer-nos e descubra por que razão o stand BestCars é a sua melhor escolha automóvel."
  ],
  motto: "BestCars - Onde a Qualidade e a Satisfação do Cliente são Prioridade!",
  stats: [
    { value: "500+", label: "Clientes Satisfeitos" },
    { value: "15+", label: "Anos de Experiência" },
    { value: "100%", label: "Transparência" },
    { value: "24h", label: "Resposta Rápida" }
  ]
};

export const filterOptions = {
  brands: ["Audi", "BMW", "Mercedes-Benz", "Peugeot", "SEAT", "VW"],
  fuels: ["Diesel", "Gasolina", "Híbrido Plug-In"],
  transmissions: ["Automática", "Manual"],
  categories: ["Carrinha", "Ligeiro de Mercadorias", "Monovolume", "SUV/TT", "Utilitário"],
  priceRange: { min: 11250, max: 36990 },
  yearRange: { min: 2014, max: 2023 },
  mileageRange: { min: 37000, max: 199000 }
};
